import {get, post} from 'src/api/http';
import * as types from './type';
import { TaskMess } from '../types';
class User {
    login (data: types.Login): Promise<any> { // 登陆
        return post('/login/sign', data);
    }
    logout (): Promise<string> {
        return post('/LoginOut');
    }
    keepLogin (): Promise<any> {
        return post('/discover/heartbeat');
    }
    setPassword (data:types.SetPassword): Promise<string> {
        return post('/set-password', data);
    }
    addUser (data: types.UserParams): Promise<TaskMess> { // 新增用户
        return post('/business/system/user/add', data);
    }
    editorUser (data: types.EditorUserParams): Promise<TaskMess> { // 编辑用户
        return post('/business/system/user/edit', data);
    }
    restPwd (data: types.RestPwdParams): Promise<string> { // 重置密码
        return post('/business/system/user/rest-pwd', data);
    }
    deleteUser (data: types.DeleteUserParams): Promise<string> { // 删除用户
        return post('/business/system/user/delete', data);
    }
    userList (data: types.UserListParams): Promise<types.UserList> { // 用户列表
        return get('/business/system/user/list', data);
    }
    userNodeTree (subSysNo:string): Promise<types.UserNode[]> { // 用户节点树，新增时的组织下拉选择
        return get(`/business/system/user/node-tree-by-login-user?subSysNo=${subSysNo}`);
    }
    userRoleList (subSysNo: string): Promise<types.UserRoleList[]> { // 角色列表，新增时选择角色下拉列表
        return get(`/business/system/user/sys-role-json?subSysNo=${subSysNo}`);
    }
    getRoleList (obj: types.RoleListQuery): Promise<types.RoleListData> { // 获取角色列表
        return get(`/business/system/role/list?sysNo=${obj.sysNo}&company=${obj.company}&page=${obj.page}&rows=${obj.rows}`);
    }
    deletRole (guid: string): Promise<TaskMess> { // 删除角色
        return post('/business/system/role/delete', {
            guid,
        });
    }
    sysModuleJson (subSysNo: string): Promise<types.menusList[]> { // 菜单树，新增时，展示菜单树
        return get(`/business/system/role/sys-module-json?subSysNo=${subSysNo}`);
    }
    addRole (params: types.AddRoleParams): Promise<TaskMess> { // 新增角色
        return post('/business/system/role/add', params);
    }
    curModuleJson (guid:string): Promise<types.curMenu[]> { // 当前角色选中的菜单树
        return get(`/business/system/role/cur-module-json?guid=${guid}`);
    }
    curModuleHomeJson (guid: string): Promise<types.curMenu[]> { // 当前角色选中的快捷菜单树
        return get(`/business/system/role/cur-module-home-json?guid=${guid}`);
    }
    editorRole (params: types.EditorRoleParams): Promise<TaskMess> { // 编辑角色
        return post('/business/system/role/edit', params);
    }
    useSessionLogin (): Promise<TaskMess> {
        return get('/useSessionLogin');
    }
    getUserSessionContent (): Promise<any> {
        return get('/getUserSessionContent');
    }
    updateAccountMsg (data: types.UpdateAccountMsgParmas): Promise<string> {
        return post('/domain/updateAccountMsg', data);
    }
    checkPassword (password:string) {
        return post('/domain/checkPassword', {password});
    }
    getNodeTree ():Promise<string[]> {
        return get('/getTreeByNodeNo');
    }
    getComListJson (sysSn: string): Promise<any[]> {
        return get('/business/system/nodes/com-list-json', {sysSn});
    }
    getOrganizationalTree (data:types.BaseLogin): Promise<types.AdOrgTreeRow> {
        return post('/ad/getOrganizationalTree', data);
    }
    saveAdMapping (data: types.SaveAdMappingParams): Promise<boolean> {
        return post('/ad/saveAdMapping', data);
    }
    batchEditStatus (data: types.BatchEditStatusParams): Promise<boolean> {
        return post('/business/system/user/edit-user-status-list', data);
    }
}

export default new User();
